import React from 'react';
import { FiLogOut } from 'react-icons/fi';
import '../styles/ProfileHeader.css';

// Debug control - use i.e. DEBUG && console.log("whatever") and set below const true
const DEBUG = process.env.REACT_APP_DEBUG == 'enabled';

const ProfileHeader = ({ onSignOut, user }) => {
  // Extract user attributes similar to UserDetails component
  const userAttributes = user?.attributes || {};
  const companyName = userAttributes.companyName || '--------';
  const globalId = userAttributes.globalId || '--------';
  const userName = userAttributes.email || '--------';

  return (
    <header className="profile-header">
      {/* Left section - Logo and Company */}
      <div className="header-left">
        <div className="logo-container">
          <img src={require('../assets/logo.png')} alt="IGEL Logo" className="logo" />
        </div>
        <div className="info-item-left">
          <span className="label">Company</span>
          <span className="value">{companyName} ({globalId})</span>
        </div>
        <div className="info-item-left">
          <span className="label">Role(s)</span>
          <span className="value">{userAttributes.cloudServicesRoles ? userAttributes.cloudServicesRoles : 'None'}</span>
        </div>
      </div>

      {/* Right section - Support info and sign out button */}
      <div className="header-right">
        <div className="support-info">
          <div className="info-item">
            {/* <span className="label">IGEL Support</span>
            <span className="value">+1 877-798-0708</span>
            <span className="value-small">PIN: 12345678</span> */}
            <span className="value">{userName}</span>
          </div>
        </div>
        <button onClick={onSignOut} className="sign-out-button" title="Sign Out">
          <FiLogOut className="icon" />
        </button>
      </div>
    </header>
  );
};

export default ProfileHeader;